import styled from "@emotion/styled";

export const Root = styled.div({
    position: "relative",
    marginBottom: 5,
});
